import React, { useEffect, useState } from 'react';
import PromoSlot from './PromoSlot';
import './TablePromoSlot.scss';

// テーブル上の商材枠の位置。desk.png と同じ座標系（1920×1024 のアクティブ領域 + globalOffsetY）で指定する。
// 位置・大きさを変えたいときはこの4つの数値だけ触ればよい。
//   cx     … 横の中心。960 が画面中央。増やすと右へ
//   bottom … 机に接する下端の位置。増やすと下へ（手前へ）
//   h      … 高さ。画像はこの高さに合わせ、横幅は元画像の比率で決まる
//   maxW   … 横長の画像が広がりすぎないための上限幅
//
// 下端を基準にしているので、画像の縦横比が変わっても「机に置かれた位置」はズレない。
const SLOT = { cx: 960, bottom: 800, h: 260, maxW: 520 };

// 縦画面では 1920×1024 のシーンが画面幅に合わせて縮むため、
// そのままだと広告が画面に対して極端に小さくなる（実測で PC の 27% に対し 7.5%）。
// 画面の縦横比から補正倍率を出して、PC と同じくらいの存在感に揃える。
function sizeBoost() {
  const ratio = window.innerWidth / window.innerHeight;
  if (ratio >= TARGET_RATIO) return 1;      // 横長（PC）はそのまま
  // 縦に余るほど大きくするが、上限は 2 倍。
  // これ以上だと広告がテーブルの奥行きを超え、カウンターより上に飛び出して
  // 「机に置いてある」感が壊れる（PC では広告の高さ ≒ テーブルの奥行き）。
  return Math.min(TARGET_RATIO / ratio, 1.6);
}

const TARGET_RATIO = 1920 / 1024;

// DeskCanvas の calcActive と同じ計算。机とズレないよう必ず揃えること
function calcActive() {
  const cw = window.innerWidth;
  const ch = window.innerHeight;
  let activeW;
  let activeH;
  if (cw / ch > TARGET_RATIO) {
    activeH = ch;
    activeW = ch * TARGET_RATIO;
  } else {
    activeW = cw;
    activeH = cw / TARGET_RATIO;
  }
  return {
    activeX: (cw - activeW) / 2,
    activeY: (ch - activeH) / 2,
    scale: activeW / 1920,
    globalOffsetY: activeH * 0.05,
  };
}

function calcStyle() {
  const { activeX, activeY, scale, globalOffsetY } = calcActive();
  const boost = sizeBoost();
  const h = SLOT.h * scale * boost;
  return {
    left: `${activeX + SLOT.cx * scale}px`,
    // 接地点（bottom）は動かさず、上へ伸ばす。机に置かれた位置を保つため
    top: `${activeY + globalOffsetY + SLOT.bottom * scale - h}px`,
    height: `${h}px`,
    maxWidth: `${SLOT.maxW * scale * boost}px`,
    // PR ラベルの大きさを広告に追従させる（PromoSlot.scss が em で参照する）
    fontSize: `${Math.max(9, h * 0.075)}px`,
  };
}

/**
 * テーブルの上に置く商材枠。
 * desk.png(z:8) より前、desk2.png(z:10) より奥に入るので、
 * 手前の机のフチに下端が少し隠れて「机に置いてある」ように見える。
 */
const TablePromoSlot = ({ promo, keyword, placementSlug, onPromoClick }) => {
  const [style, setStyle] = useState(calcStyle);

  useEffect(() => {
    const onResize = () => setStyle(calcStyle());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (!promo) return null;

  return (
    <div className="table-promo-layer">
      {/* 画像の横幅が分からなくても中央に置けるよう、外側で translateX(-50%) する */}
      <div className="table-promo-anchor" style={style}>
        <PromoSlot
          promo={promo}
          placementSlug={placementSlug}
          keyword={keyword}
          variant="table"
          // 渡し忘れると、別タブへ移ってもこちらが喋り続ける
          onPromoClick={onPromoClick}
        />
      </div>
    </div>
  );
};

export default TablePromoSlot;
